// @flow

import React from 'react';
import { I18n } from 'react-redux-i18n';
import type { VisioglobeUnitsOk } from '../../../../types/geminiType';
import { fuzzysearch } from '../../../../utils/fuzzysearch';

type Props = {
  selectSources: { label: string, id: string, store: VisioglobeUnitsOk }[],
  handleChange: (string, VisioglobeUnitsOk) => void,
  search: Function,
  searchWord: string,
  reference: Object,
  resetSearch: Function,
  selectStoreCat: Function,
  displayVisioglobeIds: ?boolean,
}

class SearchSelectStore extends React.Component<Props> {
  static defaultProps = {
    displayVisioglobeIds: false,
  }

  getValuesToDisplay = () => (
    this.props.selectSources
      ? (
        this.props.selectSources.filter((value) => {
          if (this.props.searchWord !== '' && value) {
            const fuzzyOnLabel = fuzzysearch(this.props.searchWord, value.label);
            if (this.props.displayVisioglobeIds) {
              const fuzzyOnVisioglobes = value.store.idVisioglobes.reduce((acc, idVisioglobe) =>
                acc && fuzzysearch(this.props.searchWord, idVisioglobe), true);
              return fuzzyOnLabel || fuzzyOnVisioglobes;
            }
            return fuzzyOnLabel;
          }
          return true;
        })
      ) : []
  );

  getResultsToDisplay = () => {
    const valuesToDisplay = this.getValuesToDisplay();
    if (valuesToDisplay.length > 0) {
      return (
        valuesToDisplay
          .sort((a, b) => a.label.localeCompare(b.label))
          .map(value => (
            <button
              key={value.id}
              className="search-filter"
              onClick={() => {
                this.props.handleChange(value.id, value.store);
                this.props.reference.current.value = '';
                this.props.resetSearch();
                this.props.selectStoreCat();
              }}
            >
              <p>
                {`${value.label}${this.props.displayVisioglobeIds ? ` (${value.store.idVisioglobes})` : ''}`}
              </p>
            </button>
          ))
      );
    }
    return (
      <button
        className="search-filter"
        key="no-data"
        onClick={() => {
        }}
        disabled
      >
        <p>
          {I18n.t('GEMINI.NO_RESULTS')}
        </p>
      </button>
    );
  }

  render() {
    return (
      <div className="store-name-container">
        <div
          className="select-array-container bottom"
        >
          <div
            className={`search-input ${this.props.searchWord === '' ? 'empty' : ''}`}
          >
            <input
              onChange={(e: EventHandler) => this.props.search(e)}
              placeholder="&#xF002;"
              type="search"
              value={this.props.searchWord}
              ref={this.props.reference}
            />
          </div>
          {
            this.props.searchWord !== '' &&
            <div
              role="presentation"
              className="select-array"
            >
              {this.getResultsToDisplay()}
            </div>
          }
        </div>
      </div>
    );
  }
}

export default SearchSelectStore;
